import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../../app.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'find-repair-estimate',
  templateUrl: './find-repair-estimate.component.html',
  styleUrls: ['./find-repair-estimate.component.scss']
})
export class FindRepairEstimateComponent implements OnInit {

    constructor(private _titleService: Title) { }

    ngOnInit() {
        this._titleService.setTitle('Find Undercarriage Rebuild Centre');
  }
}
